import React from "react";
import FancyTitle from "../../_shared/FancyTitle";
import s from "./TabsFancyTitle.module.css";

function TabsFancyTitle({ title, invisible = false }) {
  return (
    <div className={[s.title, invisible ? s.inv : ""].join(" ")}>
      <FancyTitle title={title} underline="no" />
    </div>
  );
}

export default TabsFancyTitle;
